import React from 'react';
import PropTypes from 'prop-types';

export class Dropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false
    };

    this.toggle = this.toggle.bind(this);
    this.handleMouseEvent = this.handleMouseEvent.bind(this);
    this.handleBlurEvent = this.handleBlurEvent.bind(this);
    this.hasFocus = this.hasFocus.bind(this);
  }

  componentDidMount() {
    this.dropdown.addEventListener('mouseup', this.handleMouseEvent);
    this.dropdown.addEventListener('focusout', this.handleBlurEvent);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { disabled } = this.props;

    if (disabled !== nextProps.disabled) {
      // If dropdown is being disabled, close it
      if (nextProps.disabled) {
        this.setState({ open: false });
      }
    }
  }

  componentWillUnmount() {
    this.dropdown.removeEventListener('mouseup', this.handleMouseEvent);
    this.dropdown.removeEventListener('focusout', this.handleBlurEvent);
  }


  hasFocus(target) {
    // when component unmounts, ref becomes null
    if (!this.dropdown) {
      return false;
    }

    const nodeIterator = document.createNodeIterator(this.dropdown, NodeFilter.SHOW_ELEMENT);
    let hasFocus = false;
    let node;

    // walk down the tree of elements from the root dropdown div
    // and see if the target of the event is a child;
    // if so, it still has focus so don't close it yet
    while ((node = nodeIterator.nextNode())) {
      if (node === target) {
        hasFocus = true;
        break;
      }
    }

    return hasFocus;
  }

  handleBlurEvent(event) {
    // the `focusout` event stores the next item to gain focus in relatedTarget
    if (!this.hasFocus(event.relatedTarget)) {
      this.setState({
        open: false
      });
    }
  }

  handleMouseEvent(event) {
    if (!this.hasFocus(event.target)) {
      this.setState({
        open: false
      });
    }
  }

  toggle() {
    this.setState({
      open: !this.state.open
    });
  }

  render() {
    const { iconWrapperClass, iconClass } = this.props;
    let icon = null;
    if (iconWrapperClass && iconClass) {
      icon = (
        <i className={iconWrapperClass}>
          <i className={iconClass} />
        </i>
      );
    } else if (!iconWrapperClass && iconClass) {
      icon = <i className={iconClass} />;
    }

    return (
      <div
        className={`pxl-dropdown ${this.props.dropdownClass} ${this.state.open ? 'open' : ''} ${this.props.disabled ? 'disabled' : ''}`}
        ref={dropdown => (this.dropdown = dropdown)}
        id={this?.props?.showOverlay && this?.props?.showOverlay === true ? 'dropdown_id_ref' : ''}
      >
        <button
          onClick={this.toggle}
          className={`pxl-btn ${this.props.btnClass} pxl-dropdown__toggle`}
          type="button"
          id={this.props.id}
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded={this.state.open}
          disabled={this.props.disabled}
        >
          {icon}
          {this.props.btnText}
        </button>
        <div className="pxl-dropdown__menu" onClick={this.props.closeOnChildClick ? this.toggle : null} aria-labelledby={this.props.id}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

Dropdown.propTypes = {
  btnClass: PropTypes.string,
  btnText: PropTypes.string,
  children: PropTypes.array.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  dropdownClass: PropTypes.string,
  iconClass: PropTypes.string,
  iconWrapperClass: PropTypes.string,
  id: PropTypes.string.isRequired,
  closeOnChildClick: PropTypes.bool
};

Dropdown.defaultProps = {
  btnClass: 'pxl-btn-default',
  btnText: 'Menu',
  children: [],
  className: '',
  dropdownClass: '',
  iconClass: '',
  iconWrapperClass: '',
  id: '',
  closeOnChildClick: false,
  disabled: false
};


export default Dropdown